import React, {Component} from 'react';
import Slider from '../components/Slider';
import {Link, browserHistory} from 'react-router';


class ArtGalleryDesktop extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imagesLoaded: 0,
      data : []
    }
  }
  labnolIframe(container_id,id) {
    var img = document.getElementById(container_id);
    var iframe = document.createElement("iframe");
    var embed = "https://www.youtube.com/embed/ID?autoplay=1";
    iframe.setAttribute("src", embed.replace("ID", id));
    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "1");
    img.replaceWith(iframe);
  }
  onLoadImage(){
    this.state.imagesLoaded++;
  }


  componentWillMount() {
    var thisState = this;
    fetch('/serverapi/getpainting', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({"artwork_url" : this.props.painting})
      }).then((resp) => resp.json())
        .then(function(data) {
          data.artwork_images.map(function(elem, index) {
            var imageObject = new Image();
            imageObject.src = "/api/viewimage/"+elem.artwork_painting_oid+"/s=800/"+elem.artwork_fname;
            data.artwork_images[index]['image'] = imageObject;
        })
        thisState.setState({ data: data.artwork_images})
      });

  }

  render() {
    var thisState = this;
    var images = [];
    images = thisState.state.data.map(function(elem, index) {
      return (
          <div key={index}><img
          onLoad={thisState.onLoadImage()}
          src={"/api/viewimage/"+elem.artwork_painting_oid+"/s=800/"+elem.artwork_fname}
          style={{
            width: "100%" }}
          role="presentation"></img></div>
        );
    });

    if (images.length > 0  && images.length === thisState.state.imagesLoaded) {
      images.push(
        <div
          className="youtube-player padding"
          onClick={() => { thisState.labnolIframe("youtube_0",this.state.data[0].artwork_video_url)}}
          >
          <img
            src={"/api/viewimage/"+this.state.data[0].artwork_painting_oid+"/s=800/"+this.state.data[0].artwork_fname}
            style={{
              width: "100%" }}
              id="youtube_0"
            className="youtube-image"
            role="presentation">
          </img>
      <div className="play"></div>
      </div>)

      return (
        <div className="main">
          <a onClick={this.props.children.onClick} className="button-times"><i className="fa fa-times fa-2x" /></a>
            <div className="outer">
              <div className="middle">
                <div className="inner">
                  <div className="slider-detail">
                    <Slider>
                    { images.map(function(elem, index) {
                        return <div key={index}>{elem}</div>
                      })
                    }
                  </Slider>
                  </div>
                  <div className="desktop-gallery-text">
                    <p>
                      <b>{this.state.data[0].artwork_name+" "}</b>
                      {this.state.data[0].artwork_description+" "+this.state.data[0].artwork_price+" € " +this.state.data[0].artwork_extra_info}
                      {
                        this.state.data[0].artwork_status.toUpperCase() === "BUY" ? (
                          <Link to={"/contact/"+encodeURIComponent(this.state.data[0].artwork_name)}>
                            <b>{" "+this.state.data[0].artwork_status.toUpperCase()}</b>
                          </Link>) : (<b>{" "+this.state.data[0].artwork_status.toUpperCase()}</b>)
                      }
                    </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
        }
        else {
          return (<div className="main"></div>);
        }
    }
}
export default ArtGalleryDesktop;



// WEBPACK FOOTER //
// ./src/components/ArtGalleryDesktop.jsx